export default __webpack_public_path__ + "static/media/help3.94b59656.png";